var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0a579b",
    width: 40.232,
    height: 36.993,
    viewBox: "0 0 40.232 36.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(-329 -459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "house-heart",
    d: "M22.512,1.992a2.682,2.682,0,0,0-3.792,0L.892,19.817a1.342,1.342,0,0,0,1.9,1.9l1.733-1.733v14.2A4.023,4.023,0,0,0,8.547,38.2H32.685a4.023,4.023,0,0,0,4.023-4.023v-14.2l1.733,1.733a1.342,1.342,0,0,0,1.9-1.9l-6.314-6.311V4.675a1.341,1.341,0,0,0-1.341-1.341H30a1.341,1.341,0,0,0-1.341,1.341V8.142ZM34.026,17.3,20.616,3.889,7.206,17.3V34.177a1.341,1.341,0,0,0,1.341,1.341H32.685a1.341,1.341,0,0,0,1.341-1.341Zm-13.41-.6c4.463-4.487,15.623,3.363,0,13.459C4.993,20.059,16.153,12.208,20.616,16.7Z",
    transform: "translate(328.5 457.792)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.69be97f45ef89e4b6c1dabb8ed51bcfc.svg";
export { ForwardRef as ReactComponent };